var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5666 8.73346C27.8759 9.04288 28.0497 9.46249 28.0497 9.90001C28.0497 10.3375 27.8759 10.7571 27.5666 11.0666L14.3666 24.2666C14.0571 24.5759 13.6375 24.7497 13.2 24.7497C12.7625 24.7497 12.3429 24.5759 12.0335 24.2666L5.43347 17.6666C5.13291 17.3554 4.9666 16.9386 4.97036 16.506C4.97411 16.0733 5.14764 15.6595 5.45357 15.3536C5.75949 15.0476 6.17333 14.8741 6.60596 14.8704C7.03858 14.8666 7.45537 15.0329 7.76657 15.3335L13.2 20.7669L25.2335 8.73346C25.5429 8.42414 25.9625 8.25037 26.4 8.25037C26.8375 8.25037 27.2571 8.42414 27.5666 8.73346Z",
    fill: "#334E68"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmCheck);
export default __webpack_public_path__ + "static/media/sm-check.0583fee664fd023b71c35db7accb5bd1.svg";
export { ForwardRef as ReactComponent };